export const MENU_ITEMS_TANK = [
  {
    name: 'userManagement',
    to: '/Tank/user/management',
    color: '#808000',
    icon: 'user',
    role: 'ADMIN',
    enabled: false,
  },
  {
    name: 'companyManagement',
    to: '/company/management',
    color: 'teal',
    icon: 'cog',
    role: 'ADMIN,PARTNER',
    enabled: true,
  },
  {
    name: 'Hierarchy Management',
    to: '/hierarchy/management',
    color: '#af5e2a',
    icon: 'cog',
    role: 'ADMIN,PARTNER',
    enabled: true,
  },
  {
    name: 'tankDeviceManagement',
    to: '/Tank/device/management',
    color: '#800000',
    icon: 'play',
    role: 'ADMIN,PARTNER,CUSTOMER',
    enabled: true,
  },
  {
    name: 'alertsAndManagement',
    to: '/Tank/alert/management',
    color: '#303D54',
    icon: 'alarm',
    role: 'ADMIN,PARTNER',
    enabled: true,
  },
  {
    name: 'deviceProvision',
    to: '/Tank/device/provision',
    color: '#1678C2',
    icon: 'plug',
    role: 'ADMIN,PARTNER,CUSTOMER,TECHNICIAN',
    enabled: true,
  },
]
